/**
 * Admin Targeting API Client
 *
 * Provides API calls for targeting rule management:
 * - List available targetable properties
 * - Preview targeting rules (user counts)
 */

import { api } from './client';

/**
 * Get list of available targetable properties.
 * @returns {Promise<{data: Array}>} Properties with operators
 */
export async function getProperties() {
  return await api.get('/admin/targeting/properties');
}

/**
 * Preview targeting rules to see how many users match.
 * @param {Object} targetingRules - Targeting rules object
 * @returns {Promise<{data: {matched_users: number, total_users: number}}>}
 */
export async function preview(targetingRules) {
  return await api.post('/admin/targeting/preview', { targeting_rules: targetingRules });
}
